module.exports = __webpack_public_path__ + "static/media/5DPO2.fcd61d6d.jpg";